import { FileIcon } from "../images";
import { Stack, Typography } from "@mui/material";
import { FeedbackFile } from "../../types/apiTypes";
import { Link } from "react-router-dom";

export const FeedbackFilesBlock = ({ files }: { files: FeedbackFile[] }) => {
  return (
    <Stack
      gap="8px"
      alignItems="flex-start"
      sx={{
        display: "-webkit-box",
        overflow: "hidden",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 1,
        textOverflow: "ellipsis",
      }}
    >
      {files.map(({ filename, url }) => (
        <Link
          key={filename}
          to={url}
          style={{
            display: "flex",
            gap: "6px",
            flexDirection: "row",
            textDecoration: "none",
            alignItems: "center",
            flexWrap: "nowrap",
            padding: "4px 0",
          }}
        >
          <FileIcon width="16px" height="16px" color="#1D3E70" />
          <Typography
            fontSize="14px"
            lineHeight="22px"
            sx={{
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 1,
              textOverflow: "ellipsis",
              color: "#0069C4",
            }}
          >
            {filename}
          </Typography>
        </Link>
      ))}
    </Stack>
  );
};
